import { Input as BaseInput } from '@base-ui/react/input';
import type { ComponentProps } from 'react';
import { cx } from '../lib/styled.tsx';
import { controlSurface } from '../lib/surfaces.ts';

export type InputProps = ComponentProps<typeof BaseInput>;

/**
 * The bare text control. Reach for {@link TextField} instead when the input
 * needs a label, description or error — this is for the cases that already have
 * their own labelling, such as a toolbar or a table cell.
 */
export function Input({ className, ...props }: InputProps) {
  return <BaseInput className={cx(controlSurface, className)} {...props} />;
}
